import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  dev: {
    apiKey: "AIzaSyAZa1VkXoOR7WmHP7K0EYKGhMAJ-GaRUP4",
    authDomain: "ardarhayam.firebaseapp.com",
    projectId: "ardarhayam",
    storageBucket: "ardarhayam.appspot.com",
    messagingSenderId: "866225066149",
    appId: "1:866225066149:web:404fc61b1320c5144d3d4c",
    measurementId: "G-KDB8EDCLWN",
  },
  prod: {
    apiKey: "AIzaSyBRUGMQD2ItErIW7itagBSeL_tvD0lQo7Q",
    authDomain: "prognos-48733.firebaseapp.com",
    projectId: "prognos-48733",
    storageBucket: "prognos-48733.firebasestorage.app",
    messagingSenderId: "1663812359",
    appId: "1:1663812359:web:3443cc8fd648fe84fe7ba2",
  },
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig.prod, {
  experimentalForceLongPolling: true,
  experimentalAutoDetectLongPolling: true,
});
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
export const functions = getFunctions(app);
